import axios from 'axios'
import { getValidToken } from './tokenUtils'
import { toast } from 'react-toastify'

const API_BASE_URL = process.env.REACT_APP_API_URL

// Create axios instance
const apiClient = axios.create({
  baseURL: API_BASE_URL,
})

// Request interceptor to add token
apiClient.interceptors.request.use(
  async (config) => {
    // Skip token refresh on login page
    if (window.location.pathname === '/login') {
      return config
    }
    
    const token = await getValidToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle token expiration
apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    if (error.response?.status === 401) {
      // Token refresh already attempted in getValidToken, redirect to login
      toast.error('Session expired. Redirecting to login...')
      setTimeout(() => {
        localStorage.removeItem('accessToken')
        localStorage.removeItem('idToken')
        localStorage.removeItem('refreshToken')
        window.location.href = '/login'
      }, 2000)
    }
    return Promise.reject(error)
  }
)

export default apiClient